module.exports = __webpack_public_path__ + "img/iot.db0762f9.svg";